export const countryDialingInfo = {
  gb: { prefix: '+44' },
  ad: { prefix: '+376' },
  ae: { prefix: '+971' },
  af: { prefix: '+93' },
  ag: { prefix: '+1 (268)' },
  ai: { prefix: '+1 (264)' },
  al: { prefix: '+355' },
  am: { prefix: '+375' },
  ao: { prefix: '+244' },
  aq: { prefix: '+672' },
  ar: { prefix: '+54' },
  as: { prefix: '+1 (684)' },
  at: { prefix: '+43' },
  au: { prefix: '+61' },
  aw: { prefix: '+297' },
  ax: { prefix: '+358 (18)' },
  az: { prefix: '+994' },
  ba: { prefix: '+387' },
  bb: { prefix: '+1246' },
  bd: { prefix: '+880' },
  be: { prefix: '+32' },
  bf: { prefix: '+226' },
  bg: { prefix: '+359' },
  bh: { prefix: '+973' },
  bi: { prefix: '+257' },
  bj: { prefix: '+229' },
  bl: { prefix: '+590' },
  bm: { prefix: '+1441' },
  bn: { prefix: '+673' },
  bo: { prefix: '+591' },
  bq: { prefix: '+599' },
  br: { prefix: '+55' },
  bs: { prefix: '+1242' },
  bt: { prefix: '+975' },
  bv: { prefix: '+47' },
  bw: { prefix: '+267' },
  by: { prefix: '+375' },
  bz: { prefix: '+501' },
  ca: { prefix: '+1' },
  cc: { prefix: '+61' },
  cd: { prefix: '+243' },
  cf: { prefix: '+236' },
  cg: { prefix: '+242' },
  ch: { prefix: '+41' },
  ci: { prefix: '+225' },
  ck: { prefix: '+682' },
  cl: { prefix: '+56' },
  cm: { prefix: '+237' },
  cn: { prefix: '+86' },
  co: { prefix: '+57' },
  cr: { prefix: '+506' },
  cu: { prefix: '+53' },
  cv: { prefix: '+238' },
  cw: { prefix: '+599' },
  cx: { prefix: '+61' },
  cy: { prefix: '+357' },
  cz: { prefix: '+420' },
  de: { prefix: '+49' },
  dj: { prefix: '+253' },
  dk: { prefix: '+45' },
  dm: { prefix: '+1767' },
  do: { prefix: '+1809' },
  dz: { prefix: '+213' },
  ec: { prefix: '+593' },
  ee: { prefix: '+372' },
  eg: { prefix: '+20' },
  eh: { prefix: '+212' },
  er: { prefix: '+291' },
  es: { prefix: '+34' },
  et: { prefix: '+251' },
  fi: { prefix: '+358' },
  fj: { prefix: '+679' },
  fk: { prefix: '+500' },
  fm: { prefix: '+691' },
  fo: { prefix: '+298' },
  fr: { prefix: '+33' },
  ga: { prefix: '+241' },
  gd: { prefix: '+1473' },
  ge: { prefix: '+995' },
  gf: { prefix: '+594' },
  gg: { prefix: '+44' },
  gh: { prefix: '+233' },
  gi: { prefix: '+350' },
  gl: { prefix: '+299' },
  gm: { prefix: '+220' },
  gn: { prefix: '+224' },
  gp: { prefix: '+590' },
  gq: { prefix: '+240' },
  gr: { prefix: '+30' },
  gs: { prefix: '+500' },
  gt: { prefix: '+502' },
  gu: { prefix: '+1671' },
  gw: { prefix: '+245' },
  gy: { prefix: '+592' },
  hk: { prefix: '+852' },
  hm: { prefix: '+672' },
  hn: { prefix: '+504' },
  hr: { prefix: '+385' },
  ht: { prefix: '+509' },
  hu: { prefix: '+36' },
  id: { prefix: '+62' },
  ie: { prefix: '+353' },
  il: { prefix: '+972' },
  im: { prefix: '+44' },
  in: { prefix: '+91' },
  io: { prefix: '+246' },
  iq: { prefix: '+964' },
  ir: { prefix: '+98' },
  is: { prefix: '+354' },
  it: { prefix: '+39' },
  je: { prefix: '+44' },
  jm: { prefix: '+1876' },
  jo: { prefix: '+962' },
  jp: { prefix: '+81' },
  ke: { prefix: '+254' },
  kg: { prefix: '+996' },
  kh: { prefix: '+855' },
  ki: { prefix: '+686' },
  km: { prefix: '+269' },
  kn: { prefix: '+1869' },
  kp: { prefix: '+850' },
  kr: { prefix: '+82' },
  kw: { prefix: '+965' },
  ky: { prefix: '+1345' },
  kz: { prefix: '+7' },
  la: { prefix: '+856' },
  lb: { prefix: '+961' },
  lc: { prefix: '+1758' },
  li: { prefix: '+423' },
  lk: { prefix: '+94' },
  lr: { prefix: '+231' },
  ls: { prefix: '+266' },
  lt: { prefix: '+370' },
  lu: { prefix: '+352' },
  lv: { prefix: '+371' },
  ly: { prefix: '+218' },
  ma: { prefix: '+212' },
  mc: { prefix: '+377' },
  md: { prefix: '+373' },
  me: { prefix: '+382' },
  mf: { prefix: '+590' },
  mg: { prefix: '+261' },
  mh: { prefix: '+692' },
  mk: { prefix: '+389' },
  ml: { prefix: '+223' },
  mm: { prefix: '+95' },
  mn: { prefix: '+976' },
  mo: { prefix: '+853' },
  mp: { prefix: '+1670' },
  mq: { prefix: '+596' },
  mr: { prefix: '+222' },
  ms: { prefix: '+1664' },
  mt: { prefix: '+356' },
  mu: { prefix: '+230' },
  mv: { prefix: '+960' },
  mw: { prefix: '+265' },
  mx: { prefix: '+52' },
  my: { prefix: '+60' },
  mz: { prefix: '+258' },
  na: { prefix: '+264' },
  nc: { prefix: '+687' },
  ne: { prefix: '+227' },
  nf: { prefix: '+672' },
  ng: { prefix: '+234' },
  ni: { prefix: '+505' },
  nl: { prefix: '+31' },
  no: { prefix: '+47' },
  np: { prefix: '+977' },
  nr: { prefix: '+674' },
  nu: { prefix: '+683' },
  nz: { prefix: '+64' },
  om: { prefix: '+968' },
  pa: { prefix: '+507' },
  pe: { prefix: '+51' },
  pf: { prefix: '+689' },
  pg: { prefix: '+675' },
  ph: { prefix: '+63' },
  pk: { prefix: '+92' },
  pl: { prefix: '+48' },
  pm: { prefix: '+508' },
  pn: { prefix: '+64' },
  pr: { prefix: '+1' },
  ps: { prefix: '+970' },
  pt: { prefix: '+351' },
  pw: { prefix: '+680' },
  py: { prefix: '+595' },
  qa: { prefix: '+974' },
  re: { prefix: '+262' },
  ro: { prefix: '+40' },
  rs: { prefix: '+381' },
  ru: { prefix: '+7' },
  rw: { prefix: '+250' },
  sa: { prefix: '+966' },
  sb: { prefix: '+677' },
  sc: { prefix: '+248' },
  sd: { prefix: '+249' },
  se: { prefix: '+46' },
  sg: { prefix: '+65' },
  sh: { prefix: '+290' },
  si: { prefix: '+386' },
  sj: { prefix: '+47' },
  sk: { prefix: '+421' },
  sl: { prefix: '+232' },
  sm: { prefix: '+378' },
  sn: { prefix: '+221' },
  so: { prefix: '+252' },
  sr: { prefix: '+597' },
  st: { prefix: '+239' },
  ss: { prefix: '+211' },
  sv: { prefix: '+503' },
  sx: { prefix: '+1721' },
  sy: { prefix: '+963' },
  sz: { prefix: '+268' },
  tc: { prefix: '+1649' },
  td: { prefix: '+235' },
  tf: { prefix: '+262' },
  tg: { prefix: '+228' },
  th: { prefix: '+66' },
  tj: { prefix: '+992' },
  tk: { prefix: '+690' },
  tl: { prefix: '+670' },
  tm: { prefix: '+993' },
  tn: { prefix: '+216' },
  to: { prefix: '+676' },
  tr: { prefix: '+90' },
  tt: { prefix: '+1868' },
  tv: { prefix: '+688' },
  tw: { prefix: '+886' },
  tz: { prefix: '+255' },
  ua: { prefix: '+380' },
  ug: { prefix: '+256' },
  um: { prefix: '+1' },
  us: { prefix: '+1' },
  uy: { prefix: '+598' },
  uz: { prefix: '+998' },
  va: { prefix: '+379' },
  vc: { prefix: '+1784' },
  ve: { prefix: '+58' },
  vg: { prefix: '+1284' },
  vi: { prefix: '+1340' },
  vn: { prefix: '+84' },
  vu: { prefix: '+678' },
  wf: { prefix: '+681' },
  ws: { prefix: '+685' },
  xk: { prefix: '+383' },
  ye: { prefix: '+967' },
  yt: { prefix: '+262' },
  za: { prefix: '+27' },
  zm: { prefix: '+260' },
  zw: { prefix: '+263' }
};